'use client';

import { SegmentPage } from '@flipster/features/src/misc/segment/segment-page';
import RewardHubV2Page from '@flipster/features/src/reward-hub-page/v2';

const Page = () => {
  return (
    <>
      <SegmentPage name='reward_hub_page_view' />
      <RewardHubV2Page />
    </>
  );
};

export default Page;
